var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { ArrayNotEmpty, IsBoolean, IsInt, IsOptional, IsString, ValidateNested } from "class-validator";
import { IsValidDateString } from "./is-valid-date-string";
import { safeAssign } from "./safe-assign";
export class GetHolidaysDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsValidDateString(),
    __metadata("design:type", String)
], GetHolidaysDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsValidDateString(),
    __metadata("design:type", String)
], GetHolidaysDTO.prototype, "to", void 0);
__decorate([
    Expose(),
    ArrayNotEmpty(),
    IsInt({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], GetHolidaysDTO.prototype, "venueIds", void 0);
export class HolidayDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsValidDateString(),
    __metadata("design:type", String)
], HolidayDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], HolidayDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], HolidayDTO.prototype, "disabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], HolidayDTO.prototype, "special", void 0);
export class VenueHolidaysDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], VenueHolidaysDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], VenueHolidaysDTO.prototype, "state", void 0);
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => HolidayDTO),
    __metadata("design:type", Array)
], VenueHolidaysDTO.prototype, "holidays", void 0);
//# sourceMappingURL=holiday.dto.js.map